// extracted by mini-css-extract-plugin
module.exports = {"expandRight":"style_expandRight___Y4vv"};